/** What a route's kind means: callers ask here rather than re-deriving it from the route's stops. */

/** Mirrors the `public.route_kind` enum. */
export type RouteKind = "operational" | "standby" | "external"

export const ROUTE_KINDS: RouteKind[] = ["operational", "standby", "external"]

/** Unrecognised values become `operational`, the answer that changes nothing. */
export function toRouteKind(value: unknown): RouteKind {
  return ROUTE_KINDS.includes(value as RouteKind) ? (value as RouteKind) : "operational"
}

/** The instance's kind wins where set, otherwise the plan's. */
export function resolveRouteKind(
  instanceRouteKind: string | null | undefined,
  planRouteKind?: string | null | undefined
): RouteKind {
  return toRouteKind(instanceRouteKind ?? planRouteKind)
}

/** External carries no Track-POD job of ours; stand-by has no customer work to record. */
export function exportsToTrackPod(kind: RouteKind): boolean {
  return kind === "operational"
}

/** Stand-by is withheld: a depot-to-depot route would put a phantom job in the driver's app. External still goes, deliberately. */
export function exportsToSamsara(kind: RouteKind): boolean {
  return kind !== "standby"
}

/** External is priced from its direct injection stops; stand-by is driver hours only. */
export function isCostedFromModel(kind: RouteKind): boolean {
  return kind === "operational"
}

/** Stand-by still needs a booked shift (an unbooked spare is a real gap); external never does. */
export function expectsShiftCover(kind: RouteKind): boolean {
  return kind !== "external"
}

/** Stand-by has no vehicle, driver or fixed depot until called on, so there is nothing to compare. */
export function reportsShiftDrift(kind: RouteKind): boolean {
  return kind === "operational"
}
